import React from 'react';
import styled from 'styled-components';

import Calender from 'icons/CalenderIcon';
import CalenderNeg from 'icons/CalenderNegIcon';
import Clock from 'icons/ClockIcon';
import ClockNeg from 'icons/ClockNegIcon';
import Cup from 'icons/CupIcon';
import CupNeg from 'icons/CupNegIcon';
import Drink from 'icons/DrinkIcon';
import DrinkNeg from 'icons/DrinkNegIcon';
import Eye from 'icons/EyeIcon';
import EyeNeg from 'icons/EyeNegIcon';
import Envelope from 'icons/EnvelopeIcon';
import Gallery from 'icons/GalleryIcon';
import GalleryNeg from 'icons/GalleryNegIcon';
import Links from 'icons/LinksIcon';
import Map from 'icons/MapIcon';
import MapNeg from 'icons/MapNegIcon';
import Ticket from 'icons/TicketIcon';
import Triangle from 'icons/TriangleIcon';
import TriangleNeg from 'icons/TriangleNegIcon';
import Trash from 'icons/TrashIcon';
import TrashNeg from 'icons/TrashNegIcon';
import Book from 'icons/BookIcon';
import BookNeg from 'icons/BookNegIcon';
import Bell from 'icons/BellIcon';
import BellNeg from 'icons/BellNegIcon';
import PaperPlane from 'icons/SendIcon';
import PaperPlaneNeg from 'icons/SendNegIcon';
import Printer from 'icons/PrinterIcon';
import PrinterNeg from 'icons/PrinterNegIcon';
import Search from 'icons/SearchIcon';
import SearchNeg from 'icons/SearchNegIcon';
import Share from 'icons/ShareIcon';
import ShareNeg from 'icons/ShareNegIcon';
import Skis from 'icons/SkisIcon';
import Sliders from 'icons/SlidersIcon';
import SlidersNeg from 'icons/SlidersNegIcon';
import Snowflake from 'icons/SnowflakeIcon';
import SnowflakeNeg from 'icons/SnowflakeNegIcon';
import Snowmobile from 'icons/SnowmobileIcon';
import SnowmobileNeg from 'icons/SnowmobileNegIcon';
import Sun from 'icons/SunIcon';
import SunNeg from 'icons/SunNegIcon';
import NorthernLights from 'icons/NorthernLightsIcon';
import NorthernLightsNeg from 'icons/NorthernLightsNegIcon';
import Info from 'icons/InfoIcon';
import InfoNeg from 'icons/InfoNegIcon';
import LightBulb from 'icons/LightBulbIcon';
import LightBulbNeg from 'icons/LightBulbNegIcon';
import Arrow from 'icons/ArrowIcon';
import User from 'icons/UserIcon';
import UserNeg from 'icons/UserNegIcon';
import WiFi from 'icons/WiFiIcon';

export const IconSelector = props => {
    const switchIcons = () => {
        switch(props.icon) {
            case 'arrow':
                return <Arrow />
            case 'bell':
                return props.negative ? <BellNeg /> : <Bell />
            case 'book':
                return props.negative ? <BookNeg /> : <Book />
            case 'calender':
                return props.negative ? <CalenderNeg /> : <Calender />
            case 'clock':
                return props.negative ? <ClockNeg /> : <Clock />
            case 'cup':
                return props.negative ? <CupNeg /> : <Cup />
            case 'difficulty':
                return props.negative ? <SlidersNeg /> : <Sliders />
            case 'drink':
                return props.negative ? <DrinkNeg /> : <Drink />
            case 'eye':
                return props.negative ? <EyeNeg /> : <Eye />
            case 'envelope':
                return <Envelope />
            case 'gallery':
                return props.negative ? <GalleryNeg /> : <Gallery />
            case 'info':
                return props.negative ? <InfoNeg /> : <Info />
            case 'light_bulb':
                return props.negative ? <LightBulbNeg /> : <LightBulb />
            case 'links':
                return <Links />
            case 'map':
                return props.negative ? <MapNeg /> : <Map />
            case 'northern_lights':
                return props.negative ? <NorthernLightsNeg /> : <NorthernLights />
            case 'paper_plane':
                return props.negative ? <PaperPlaneNeg /> : <PaperPlane />
            case 'printer':
                return props.negative ? <PrinterNeg /> : <Printer />
            case 'search':
                return props.negative ? <SearchNeg /> : <Search />
            case 'share':
                return props.negative ? <ShareNeg /> : <Share />
            case 'skis':
                return <Skis />
            case 'snowflake':
                return props.negative ? <SnowflakeNeg /> : <Snowflake />
            case 'snowmobile':
                return props.negative ? <SnowmobileNeg /> : <Snowmobile />
            case 'sun':
                return props.negative ? <SunNeg /> : <Sun />
            case 'ticket':
                return <Ticket />
            case 'triangle':
                return props.negative ? <TriangleNeg /> : <Triangle />
            case 'trash':
                return props.negative ? <TrashNeg /> : <Trash />
            case 'user':
                return props.negative ? <UserNeg /> : <User />
            case 'wifi':
                return <WiFi />
            default:
                return null;
        }
    }

return <IconWrapper className={props.className}  noMargin={props.noMargin}>{switchIcons()}</IconWrapper>
}

export default IconSelector;


const IconWrapper = styled.span`
    align-self: center;
    display: flex;
    align-items: center;
    min-width: 26px;
    margin-right: ${props => props.noMargin ? 0 : props.theme.spacing.contentS};

    svg {
        height: 26px;
    }
`